import React from 'react';
import { createNavigationSchema } from './SiteNavigationElementSchema.utils';
import { Helmet } from '../../../../modules/foundation/components/HelmetProvider';
var SiteNavigationElementSchema = function SiteNavigationElementSchema(_ref) {
  var navigationElementId = _ref.navigationElementId,
    siteUrl = _ref.siteUrl,
    pages = _ref.pages;
  var navigationData = createNavigationSchema(pages, siteUrl, navigationElementId);
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(navigationData)));
};
export default SiteNavigationElementSchema;
SiteNavigationElementSchema.defaultProps = {
  navigationElementId: '#nav'
};